import { getMvms, getMvmsStatus } from '@/api/mvms'

const state = {
  mvms: []
}

const mutations = {
  setMvms(state, payload) {
    state.mvms = payload
  }
}

const actions = {
  async getMvms({ commit }) {
    const mvms = await getMvms()
    commit('setMvms', mvms)
  }
}

const getters = {
  mvms(state) {
    return state.mvms
  },
  mvmsStatus(state) {
    const mvmsStatus = []
    const condition = { 1: '在線', 0: '離線', 4: '未註冊', 2: '低庫存' }
    for (const key in condition) {
      const data = state.mvms.filter((obj) => {
        return obj.Status === key
      })
      mvmsStatus.push({ title: condition[key], mvms: data, sum: data.length })
    }
    return mvmsStatus
  },
  DSales(state) {
    return state.DSales
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
